const dropDownText = {
	dropDownErrorMsg: 'Limited to 30 Accounts or groups',
};

export default dropDownText;
